import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const LoginForm3 = ({ className = "" }) => {
  const navigate = useNavigate();

  const onRectangleClick = useCallback(() => {
    navigate("/22-login-pass");
  }, [navigate]);

  return (
    <section
      className={`self-stretch flex flex-row items-start justify-start py-0 px-10 box-border max-w-full text-left text-base text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div className="flex-1 flex flex-col items-end justify-start gap-[19.5px] max-w-full">
        <div className="self-stretch h-[60px] rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border flex flex-row items-start justify-start py-[17px] px-[29px] max-w-full">
          <div className="h-[60px] w-[360px] relative rounded-81xl bg-light-primary-key-background border-dark-text border-solid border-[2px] box-border hidden max-w-full" />
          <div className="relative z-[1]">test.email@gmail.com</div>
        </div>
        <div className="self-stretch h-[60px] relative text-light-text">
          <div
            className="absolute top-[0px] left-[0px] rounded-81xl bg-light-primary-key-background border-dark-orange border-solid border-[2px] box-border w-full h-full cursor-pointer"
            onClick={onRectangleClick}
          />
          <div className="absolute top-[20px] left-[29px]">*******</div>
          <img
            className="absolute top-[18px] left-[314px] w-6 h-6 overflow-hidden z-[1]"
            loading="lazy"
            alt=""
            src="/error-outline.svg"
          />
        </div>
        <div className="relative text-dark-orange text-right">
          Quên mật khẩu
        </div>
      </div>
    </section>
  );
};

LoginForm3.propTypes = {
  className: PropTypes.string,
};

export default LoginForm3;
